var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-tag"},[(_vm.label)?_c('el-tag',{attrs:{"size":"mini","type":_vm.value === 'N'
        ? 'warning'
        : _vm.value === 'S'
        ? 'danger'
        : _vm.value === 'Y'
        ? 'success'
        : ''}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }